import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IRecipe } from './../models/recipes.model';
import { RecipesService } from './../services/recipes.service';
import { RouterLink } from '@angular/router';
import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { SeoService } from '../services/seo.service';
import * as SEO from 'src/app/shared/seo.tags';
import { DEFAULT_IMAGE_URL } from '../shared/utils';
import { AsHttpParams } from '../models/AsHttpParams.model';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { isPlatformBrowser, NgOptimizedImage, SlicePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-recipes',
  templateUrl: './recipes.component.html',
  styleUrls: ['./recipes.component.scss'],
  standalone: true,
  imports: [LottieComponent, MatFormFieldModule, RouterLink, LazyLoadImageModule, MatIconModule, FormsModule, ReactiveFormsModule, MatInputModule, MatSelectModule, MatOptionModule, SlicePipe, TranslateModule, NgOptimizedImage, LazyLoadImageModule]
})
export class RecipesComponent implements OnInit, OnDestroy {

  public page = 1;
  public limit = 15;
  public search: string;
  public categories: any[] = [];
  public newestRecipes: IRecipe[] = [];
  public recommendedRecipes: IRecipe[] = [];
  public weekRecipe: IRecipe;
  public loading = false;
  public filterForm: UntypedFormGroup;
  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };
  public totalRecipes = 1;
  public defaultImage: string = DEFAULT_IMAGE_URL;

  private subs = new Subject<void>();

  constructor(
    private recipesService: RecipesService,
    private fb: UntypedFormBuilder,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    this.setSEOSettings();
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
    this.getRecipes();
    this.filterForm.valueChanges.pipe(
      takeUntil(this.subs),
      debounceTime(400)
    )
      .subscribe(
        () => {
          this.getRecipes();
        }
      );
  }

  ngOnDestroy(): void {
    this.subs.next();
    this.subs.complete();
  }

  public setSEOSettings(): void {
    this.seoService.updateTitle(SEO.TAGS_RECIPES.title);
    this.seoService.updateDescription(SEO.TAGS_RECIPES.description);
    if (isPlatformBrowser(this.platformId)) {
      this.seoService.createLinkForCanonicalURL(window.location.href);
      this.seoService.updateUrl(window.location.href);
    }
  }

  public createForm(): void {
    this.filterForm = this.fb.group({
      search: [''],
      categories: ['all']
    });
  }

  public async getRecipes(): Promise<void> {
    this.newestRecipes = [];
    this.recommendedRecipes = [];
    this.loading = true;
    try {
      const resp = await this.recipesService.getCategories();
      this.categories = resp.data.categories;
      const params: AsHttpParams = {
        page: String(this.page),
        limit: String(this.limit)
      };
      if (this.filterForm.get('search')?.value) {
        params.search = this.filterForm.get('search')?.value;
      }
      if (this.filterForm.get('categories')?.value && this.filterForm.get('categories')?.value !== 'all') {
        params.category_id = this.filterForm.get('categories')?.value;
      }
      const { data } = await this.recipesService.getRecipes(params);
      this.totalRecipes = data.total;
      data?.recipes.forEach((item: any) => {
        item.color = {
          background: item.color
        };
        switch (item.recipe_type) {
          case 'RECETA_DE_LA_SEMANA':
            this.weekRecipe = item;
            break;
          case 'LO_MAS_NUEVO':
            this.newestRecipes.push(item);
            break;
          case 'RECOMENDADO':
            this.recommendedRecipes.push(item);
            break;
        }
      });
      const x = this.weekRecipe.recipe_title.split(' ');
      this.weekRecipe.recipe_url = `/recetas/${x.join('-').toLowerCase()}-${this.weekRecipe.recipe_id}`;
      this.newestRecipes.forEach((item: any) => {
        const x = item.recipe_title.split(' ');
        item.recipe_url = `/recetas/${x.join('-').toLowerCase()}-${item.recipe_id}`;
      });
      this.recommendedRecipes.forEach((item: any) => {
        const x = item.recipe_title.split(' ');
        item.recipe_url = `/recetas/${x.join('-').toLowerCase()}-${item.recipe_id}`;
      });
      this.loading = false;
    } catch (error) {
      this.totalRecipes = 0;
      this.loading = false;
    }
  }
}
